import type { ReactNode } from 'react';
import { cx } from './cx';

export type BadgeTone =
  | 'success'
  | 'warning'
  | 'error'
  | 'info'
  | 'blue'
  | 'admin'
  | 'neutral';

const toneStyles: Record<BadgeTone, string> = {
  success: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
  warning: 'bg-amber-500/10 text-amber-400 border-amber-500/20',
  error:   'bg-red-500/10 text-red-400 border-red-500/20',
  info:    'bg-cyan-500/10 text-cyan-400 border-cyan-500/20',
  blue:    'bg-blue-500/10 text-blue-400 border-blue-500/20',
  admin:   'bg-purple-500/10 text-purple-400 border-purple-500/20',
  neutral: 'bg-slate-500/10 text-slate-400 border-slate-500/20',
};

export interface BadgeProps {
  tone?: BadgeTone;
  dot?: boolean;
  className?: string;
  children: ReactNode;
}

export function Badge({ tone = 'neutral', dot = false, className, children }: BadgeProps) {
  return (
    <span
      className={cx(
        'inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-semibold border',
        toneStyles[tone],
        className,
      )}
    >
      {dot && <span className="w-1.5 h-1.5 rounded-full bg-current" />}
      {children}
    </span>
  );
}
